/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecentAccess } from '../../models/recent-access';

export interface ServerStatusControllerGetAllRecentAccess$Params {
}

export function serverStatusControllerGetAllRecentAccess(http: HttpClient, rootUrl: string, params?: ServerStatusControllerGetAllRecentAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RecentAccess>>> {
  const rb = new RequestBuilder(rootUrl, serverStatusControllerGetAllRecentAccess.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RecentAccess>>;
    })
  );
}

serverStatusControllerGetAllRecentAccess.PATH = '/server-status/recentAccesses';
